import { SoundSet, ThereminvoxBackendSettings, ThereminvoxSettings } from '../../model/settings';
import { isValidThereminvoxSoundMeta } from '../../model/thereminvox';
import { ThereminvoxFormSettings } from '../../types';

const defaultSoundSet: SoundSet = {
    sounds: [],
    settings: {
        repeatSoundInside: false,
        noOverlaySamples: false,
        stopOnCeil: false,
    },
};

export function mapValuesToThereminvoxSettings(values: ThereminvoxFormSettings): Partial<ThereminvoxSettings> {
    return {
        logo2: null,
        name: values.name,
        hideInStore: true, // пока-что навыки thereminvox всегда приватные
        backendSettings: {
            soundSet: {
                sounds: values.soundsMeta.filter(isValidThereminvoxSoundMeta),
                settings: {
                    noOverlaySamples: values.noOverlaySamples,
                    repeatSoundInside: values.repeatSoundInside,
                    stopOnCeil: values.stopOnCeil,
                },
            },
        },
    };
}

export function mapThereminvoxSettingsToValues(skillSettings: ThereminvoxSettings): ThereminvoxFormSettings {
    const { soundSet = defaultSoundSet } = {
        ...skillSettings.backendSettings,
    } as ThereminvoxBackendSettings;

    return {
        soundsMeta: soundSet.sounds,
        noOverlaySamples: soundSet.settings.noOverlaySamples,
        repeatSoundInside: soundSet.settings.repeatSoundInside,
        stopOnCeil: soundSet.settings.stopOnCeil,

        name: skillSettings.name,
        hideInStore: true, // пока-что навыки thereminvox всегда приватные
    };
}
